const getRecommendationKey = (recommendation)=>{
    return recommendation.recommendationType === 'banner' ? `${recommendation.position}-${recommendation.title}` : recommendation.sku;
};

export { getRecommendationKey };
//# sourceMappingURL=get-recommendation-key.js.map
